import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        wrapper: {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            width: '300px',
        },
        autocomplete: {
            width: '100%',
            '& .MuiAutocomplete-endAdornment': {
                top: 'unset !important',
                bottom: '-10px !important',
            },
        },
        option: {
            borderBottom: `1px solid ${theme.palette.secondary[200]}`,
            '&[aria-selected="true"]': {
                backgroundColor: `${theme.palette.primary[30]} !important`,
            },
            '&:hover': {
                backgroundColor: `${theme.palette.primary[50]} !important`,
            },
        },
        optionLabel: {
            '& .MuiTypography-root': {
                color: `${theme.palette.text.primary} !important`,
            },
        },
        dropdown: {
            '& .MuiAutocomplete-listbox': {
                paddingBottom: '0 !important',
            },
        },

    }
})

export default useStyles
